/** Lädt die Preline-Dropdown-API erst im Browser (eigene Datei, damit Tests sie ersetzen können). */
export type DropdownApi = {
  open: (el: HTMLElement) => void;
  close: (el: HTMLElement) => void;
};

export async function ladeDropdownApi(): Promise<DropdownApi> {
  const { HSDropdown } = await import("preline/non-auto");
  return HSDropdown as unknown as DropdownApi;
}
